export const maxRowBasedquery = '(min-width: 1000px)'